import { TFunction } from "i18next";

import { OrderPaymentStatus } from "../../../../../../../redux/constants/OrdersPage/order";

import type { Order } from "../../../../../../../services";

const paymentColors = {
	[OrderPaymentStatus.PAYMENT_PENDING]: {
		backgroundColor: "#03A9F4",
		textColor: "#FFFFFF",
	},
	[OrderPaymentStatus.PAYMENT_FAILED]: {
		backgroundColor: "#f83528",
		textColor: "#FFFFFF",
	},
	[OrderPaymentStatus.PAYMENT_SUCCESS]: {
		backgroundColor: "#4caf50",
		textColor: "#FFFFFF",
	},
	[OrderPaymentStatus.CARD_VALIDATION]: {
		backgroundColor: "#03A9F4",
		textColor: "#FFFFFF",
	},
	[OrderPaymentStatus.CARD_VALIDATION_FAILED]: {
		backgroundColor: "#f83528",
		textColor: "#FFFFFF",
	},
	[OrderPaymentStatus.CARD_VALIDATION_SUCCESS]: {
		backgroundColor: "#4caf50",
		textColor: "#FFFFFF",
	},
	[OrderPaymentStatus.PAYMENT_PART]: {
		backgroundColor: "#FFD8D9",
		textColor: "#FFFFFF",
	},
};

const cellProcessing = (
	item: Order.Model,
	t: TFunction,
): { content: string; backgroundColor?: string; textColor?: string } => {
	const content = t(`order_payment_type.${item.paymentType}`);
	const status = item.paymentStatus?.status;

	const colors = status ? paymentColors[status] ?? {} : {};

	return {
		content,
		backgroundColor: colors.backgroundColor,
		textColor: colors.textColor,
	};
};

export default cellProcessing;
